module.exports = __webpack_public_path__ + "static/media/Realtime_Notification.6bd942f9.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/Realtime_Notification.mov
// module id = 596
// module chunks = 0